import React from 'react';
import styled from 'styled-components';
import { Text, Thumbnail, theme, PriceTag } from 'components';
import { CreateListingCardProps, SmallPreviewFields } from '../types';

type SmallPreviewProps = CreateListingCardProps<SmallPreviewFields>;

const SmallPreview: React.FC<SmallPreviewProps> = ({
  thumbnail,
  line1,
  line2,
  city,
  province,
  postal_code,
  list_price,
}) => (
  <StyledListingPreview>
    <Thumbnail src={thumbnail} />
    <div>
      <Text strong block data-cy="preview-listing-address">
        {line1} {line2 || ''}
      </Text>
      <Text type="secondary">
        {city}, {province} {postal_code}
      </Text>
    </div>
    <div>
      <PriceTag price={list_price} />
    </div>
  </StyledListingPreview>
);

const StyledListingPreview = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-column-gap: 15px;
  align-items: center;
  border: 1px solid ${theme.gray4};
  border-radius: ${theme.getBorderRadius('medium')};
  padding: 10px;
`;

export default React.memo(SmallPreview);
